import React, { CSSProperties, MouseEventHandler } from 'react';
import cls from 'classnames';
import styles from "./Switch.module.scss";

export type SwitchProps = {
  className?: string;
  dimmed?: boolean;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean, event?: React.MouseEvent | React.ChangeEvent) => void;
  testId?: string;
  style?: CSSProperties;
  onClick?: MouseEventHandler;
  onClickCapture?: MouseEventHandler;
}

/**
 * Simple switch. Does not have an internal state.
 */
export const Switch: React.FC<SwitchProps> = ({
  checked, disabled, dimmed, testId, style, className, onChange, onClick, ...dataProps
}) => (
  <div
    role="checkbox"
    aria-checked={Boolean(checked)}
    style={style}
    data-testid={testId}
    data-checked={Boolean(checked)}
    onClick={event => {
      onClick?.(event);
      onChange?.(!checked, event);
    }}
    className={cls([
      styles.switch,
      disabled ? styles.disabled : null,
      checked ? styles.checked : null,
      dimmed ? styles.dimmed : null
    ])}
    {...dataProps}>
    <div className={styles.knob}></div>
  </div>
);